import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\VoteController::results
* @see app/Http/Controllers/VoteController.php:108
* @route '/api/{edition}/votes/{vote}/results'
*/
export const results = (args: { edition: string | number, vote: number | { id: number } } | [edition: string | number, vote: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: results.url(args, options),
    method: 'get',
})

results.definition = {
    methods: ["get","head"],
    url: '/api/{edition}/votes/{vote}/results',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\VoteController::results
* @see app/Http/Controllers/VoteController.php:108
* @route '/api/{edition}/votes/{vote}/results'
*/
results.url = (args: { edition: string | number, vote: number | { id: number } } | [edition: string | number, vote: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            edition: args[0],
            vote: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
        vote: typeof args.vote === 'object'
        ? args.vote.id
        : args.vote,
    }

    return results.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace('{vote}', parsedArgs.vote.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\VoteController::results
* @see app/Http/Controllers/VoteController.php:108
* @route '/api/{edition}/votes/{vote}/results'
*/
results.get = (args: { edition: string | number, vote: number | { id: number } } | [edition: string | number, vote: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: results.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoteController::results
* @see app/Http/Controllers/VoteController.php:108
* @route '/api/{edition}/votes/{vote}/results'
*/
results.head = (args: { edition: string | number, vote: number | { id: number } } | [edition: string | number, vote: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: results.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\VoteController::results
* @see app/Http/Controllers/VoteController.php:108
* @route '/api/{edition}/votes/{vote}/results'
*/
const resultsForm = (args: { edition: string | number, vote: number | { id: number } } | [edition: string | number, vote: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: results.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoteController::results
* @see app/Http/Controllers/VoteController.php:108
* @route '/api/{edition}/votes/{vote}/results'
*/
resultsForm.get = (args: { edition: string | number, vote: number | { id: number } } | [edition: string | number, vote: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: results.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoteController::results
* @see app/Http/Controllers/VoteController.php:108
* @route '/api/{edition}/votes/{vote}/results'
*/
resultsForm.head = (args: { edition: string | number, vote: number | { id: number } } | [edition: string | number, vote: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: results.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

results.form = resultsForm

/**
* @see \App\Http\Controllers\VoteController::cast
* @see app/Http/Controllers/VoteController.php:59
* @route '/api/{edition}/vote/cast'
*/
export const cast = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cast.url(args, options),
    method: 'post',
})

cast.definition = {
    methods: ["post"],
    url: '/api/{edition}/vote/cast',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\VoteController::cast
* @see app/Http/Controllers/VoteController.php:59
* @route '/api/{edition}/vote/cast'
*/
cast.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return cast.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\VoteController::cast
* @see app/Http/Controllers/VoteController.php:59
* @route '/api/{edition}/vote/cast'
*/
cast.post = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cast.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\VoteController::cast
* @see app/Http/Controllers/VoteController.php:59
* @route '/api/{edition}/vote/cast'
*/
const castForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cast.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\VoteController::cast
* @see app/Http/Controllers/VoteController.php:59
* @route '/api/{edition}/vote/cast'
*/
castForm.post = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cast.url(args, options),
    method: 'post',
})

cast.form = castForm

/**
* @see \App\Http\Controllers\VoteController::votes
* @see app/Http/Controllers/VoteController.php:81
* @route '/{edition}/votes'
*/
export const votes = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: votes.url(args, options),
    method: 'get',
})

votes.definition = {
    methods: ["get","head"],
    url: '/{edition}/votes',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\VoteController::votes
* @see app/Http/Controllers/VoteController.php:81
* @route '/{edition}/votes'
*/
votes.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return votes.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\VoteController::votes
* @see app/Http/Controllers/VoteController.php:81
* @route '/{edition}/votes'
*/
votes.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: votes.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoteController::votes
* @see app/Http/Controllers/VoteController.php:81
* @route '/{edition}/votes'
*/
votes.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: votes.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\VoteController::votes
* @see app/Http/Controllers/VoteController.php:81
* @route '/{edition}/votes'
*/
const votesForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: votes.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoteController::votes
* @see app/Http/Controllers/VoteController.php:81
* @route '/{edition}/votes'
*/
votesForm.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: votes.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoteController::votes
* @see app/Http/Controllers/VoteController.php:81
* @route '/{edition}/votes'
*/
votesForm.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: votes.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

votes.form = votesForm

/**
* @see \App\Http\Controllers\VoteController::vote
* @see app/Http/Controllers/VoteController.php:19
* @route '/{edition}/vote'
*/
export const vote = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: vote.url(args, options),
    method: 'get',
})

vote.definition = {
    methods: ["get","head"],
    url: '/{edition}/vote',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\VoteController::vote
* @see app/Http/Controllers/VoteController.php:19
* @route '/{edition}/vote'
*/
vote.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return vote.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\VoteController::vote
* @see app/Http/Controllers/VoteController.php:19
* @route '/{edition}/vote'
*/
vote.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: vote.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoteController::vote
* @see app/Http/Controllers/VoteController.php:19
* @route '/{edition}/vote'
*/
vote.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: vote.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\VoteController::vote
* @see app/Http/Controllers/VoteController.php:19
* @route '/{edition}/vote'
*/
const voteForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: vote.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoteController::vote
* @see app/Http/Controllers/VoteController.php:19
* @route '/{edition}/vote'
*/
voteForm.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: vote.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoteController::vote
* @see app/Http/Controllers/VoteController.php:19
* @route '/{edition}/vote'
*/
voteForm.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: vote.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

vote.form = voteForm

const VoteController = { results, cast, votes, vote }

export default VoteController